import React from 'react';

import LinksAuthMenu from './LinksAuthMenu';

import css from './AuthMenu.module.css';

const AuthMenu = ({ intl }) => {
  const links = [{ id: 1, type: 'signup' }, { id: 2, type: 'login' }];

  return (
    <div className={css.authMenu}>
      <LinksAuthMenu id="linksAuthMenu" links={links} intl={intl} />
    </div>
  );
};

export default AuthMenu;
